import componentsReducer, { StoreComponentsActions } from "@store/Framework/Store/Store/Components/ComponentsReducer";
import dataReducer, { StoreDataActions } from "@store/Framework/Store/Store/Data/DataReducer";
import pagesReducer, { StorePagesActions } from "@store/Framework/Store/Store/Pages/PagesReducer";
import { combineReducers } from "redux";

const storeReducers = {
    data: dataReducer,
    pages: pagesReducer,
    components: componentsReducer,
};

export type StoreActions = StorePagesActions | StoreDataActions | StoreComponentsActions;
export default combineReducers(storeReducers);
